import { Grid, IconButton, Paper, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { AdvertisementType } from "@/common/types"
import useDeleteAdvertisement from "@/hooks/api/advertisements/useDeleteAdvertisement"
import { useSnackbar } from "@/contexts/SnackbarContext"
import useDialogState from "@/hooks/useDialogState"
import EditAdvertisementDialog from "@/dialogs/advertisements/EditAdvertisementDialog"

interface AdvertisementCardProps {
  advertisement: AdvertisementType
}

export default function AdvertisementCard({
  advertisement,
}: AdvertisementCardProps) {
  const { showSnackbar } = useSnackbar()
  const { mutateAsync: deleteAd } = useDeleteAdvertisement()
  const { openDialog, ...dialogState } = useDialogState({})

  const handleDelete = () => {
    deleteAd(advertisement.advertisement_id).then(() => {
      showSnackbar("Deleted Advertisement", "success")
    })
  }

  // const handle

  return (
    <Paper
      sx={{
        padding: 2,
        borderRadius: "12px",
        borderColor: "stroke",
        borderStyle: "solid",
        borderWidth: "1px",
        margin: 2,
      }}
    >
      <Grid container>
        <Grid item xs={3}>
          <Typography>{advertisement.company_name}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>
            {/* {dayjs(event.event_start_timestamp).format("MMMM DD, YYYY HH:mm")} */}
          </Typography>
        </Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs={1}>
          <IconButton sx={{ padding: 0 }} onClick={openDialog}>
            <EditIcon color="primary" />
          </IconButton>
        </Grid>
        <Grid item xs={1}>
          <IconButton sx={{ padding: 0 }} onClick={handleDelete}>
            <DeleteIcon color="error" />
          </IconButton>
        </Grid>
      </Grid>
      <EditAdvertisementDialog {...dialogState} advertisement={advertisement} />
    </Paper>
  )
}
